import { Component, OnInit } from '@angular/core'
import { MetaService } from 'src/app/shared/services/meta.service'

import { Incentive } from '../../shared/interfaces/resources/incentive.interface'
import { BreadcrumbService } from '../../shared/services/breadcrumb.service'
import { FavoriteService } from '../../shared/services/favorite.service'
import { FilterService } from '../../shared/services/filter.service'
import { IncentiveService } from '../../shared/services/incentive.service'

@Component({
  selector: 'app-comparator',
  templateUrl: './comparator.component.html',
  styleUrls: ['./comparator.component.scss']
})
export class ComparatorComponent implements OnInit {
  favoriteIncentiveIds: string[]
  loadingDownload: boolean = false
  savedFilters: { [key: string]: string[] } = {}

  constructor(
    breadcrumbService: BreadcrumbService,
    private incentiveService: IncentiveService,
    private favoriteService: FavoriteService,
    private filterService: FilterService,
    metaService: MetaService
  ) {
    metaService.setTags('comparator')
    breadcrumbService.breadcrumbLinks.next([{ label: 'Compare incentives' }])
  }

  ngOnInit(): void {
    this.favoriteIncentiveIds = this.favoriteService.list().map((s) => s.id)
    this.savedFilters = this.filterService.getSavedFilters()
  }

  async downloadIncentives(incentiveIds: string[]): Promise<void> {
    this.loadingDownload = true
    await this.incentiveService.download(incentiveIds)
    this.loadingDownload = false
  }

  onOrderChanged(incentives: Incentive[]): void {
    this.favoriteService.replaceByNewValues(incentives)
  }
}
